// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation_sub_list ul{
    padding: 10px 140px 0px 140px !important;
}
.subMenu {
    min-height: 100vh;
}


.nav-sub-box{
    width: fit-content;
    display: flex;
    justify-content: space-between;
    padding-left:20px;
    padding-right: 5px;
    margin-right: 0;
    position: absolute;
    z-index: 999;
    top: 35px;
    left: 0;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.85);
}
.list-box{
    padding: 20px 0 0.5rem 0;
}
.list-box ul{
    padding-left: 0;
    background: transparent;
    justify-content: space-between;
}
.nav-sub-sub-list li{
    margin-right: -5px !important;
    display: none;
}
.list-box ul li{
    text-decoration: none;
    margin-bottom: 10px;
    color: #fff;
    height: 36px;
   
}
.list-box ul li:hover{
    text-decoration: none;
}
.list-box ul li a{
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    color: white;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    width: 102.5%;
    border-bottom: 1px solid #FFF;
    margin-bottom: 10px;
    padding-bottom: 12px;
    transition:all ease 1.2s !important;
    text-decoration: none;
}
.list-box ul li:last-child a, .list-box ul li:last-child a:hover {
    border-bottom: none;
}

.list-box ul li a:hover{
    text-decoration: none;
    background: transparent;
    color: #FAEC24;
    /* border-bottom: 1px solid #FAEC24; */
}
.list-box ul li a:focus{
    background-color: transparent;
    color: #FAEC24;
}

.nav-sub-sub-list li {
    margin-bottom: 10px !important;
    text-align: center !important;
}
.nav-sub-sub-list li a{
    width: fit-content;
    font-size: 12.8px !important;
    color: black !important;
    border-bottom: none !important;
    /* background: white; */
    padding: 2px 9px;
    border-radius: 10px;
}
.dropdown-menu .clicked{
    display: none;
}
.nav-sub-sub-list li a:hover{
    color: #FFF !important;
    background-color: rgba(255, 255, 255, 0.295) !important;
}
.nav-sub-sub-list{
    display: block;
}
.nav-sub-sub-list .active{
    display: none;
}

@media (max-width: 564px){
    
    .nav-sub-box {
        width: 100%;
        display: block;
        margin-right: 0;
        display: block;
        padding: 0;
        /* height: 100vh; */
        background: #000;
        position: static;
      }
      .list-box ul li a{
        text-align: left;
        width: 105%;
        border-bottom: 1px solid #FFF;
        margin-bottom: 10px;
        color: #FFF;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 380;
        line-height: normal;

    }
    .nav-sub-sub-list li a{
        width: fit-content;
        font-size: 16px !important;
        color: black !important;
        border-bottom: none !important;
        background: white;
        padding: 5px 27px !important;
        border-radius: 10px;
        margin-top: 10px;
    }
    .nav-sub-sub-list li {
    margin-bottom: 15px !important;    
    text-align: left !important;

    }
    .list-box ul{
        margin-top: 15px;
    }
    .list-box ul li{
        border-bottom: none;
        margin-bottom: 13px;
    }
    .list-box{
        padding: 0px 0 1.0125rem 0;
    }
    .dropdown-menu .dropdown-item{
        color: white;
        padding-left: 20px !important;
        font-size: 16px;
    }
    .navigation__nav .subMenu li {
        padding-left: 50px;
    }
}
@media (min-width:768px) and (max-width:992px) {
    .nav-sub-box {
        width: 100%;
        display: block;
        margin-right: 0;
        padding: 0;
        position: static;
        /* height: 100vh; */
        background: #000;
        padding-bottom: 25px !important;
      }
      .nav-sub-sub-list li a{
        width: fit-content;
        font-size: 18px !important;
        color: black !important;
        border-bottom: none !important;
        background: white;
        padding: 5px 17px !important;
        border-radius: 10px;
        margin-top: 20px;
    }
    .nav-sub-sub-list li {
    margin-bottom: 30px !important;    
    }
    .list-box ul{
        margin-top: 0 !important;
    }
    .list-box ul li{
        border-bottom: none;
        margin-bottom: 20px;
    }
    .list-box{
        padding: 0px 0 1.0125rem 0;
    }
    .dropdown-menu .dropdown-item{
        color: white;
        font-size: 17px !important;
        font-weight: 380 !important;
        padding: 20px;
    }
    .navigation__nav .subMenu li {
        padding-left: 90px;
    }
    
}
@media (min-width:1400px){
    .nav-sub-sub-list li{
        margin-right: -13px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/common-componets/NavSubList.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,OAAO;IACP,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,uBAAuB;IACvB,8BAA8B;AAClC;AACA;IACI,6BAA6B;IAC7B,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,YAAY;;AAEhB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qCAAqC;IACrC,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;IACd,sCAAsC;AAC1C;AACA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,uBAAuB;IACvB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,uDAAuD;AAC3D;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;;IAEI;QACI,WAAW;QACX,cAAc;QACd,eAAe;QACf,cAAc;QACd,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;MAClB;MACA;QACE,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,mBAAmB;QACnB,WAAW;QACX,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;;IAEvB;IACA;QACI,kBAAkB;QAClB,0BAA0B;QAC1B,uBAAuB;QACvB,8BAA8B;QAC9B,iBAAiB;QACjB,4BAA4B;QAC5B,mBAAmB;QACnB,gBAAgB;IACpB;IACA;IACA,8BAA8B;IAC9B,2BAA2B;;IAE3B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,YAAY;QACZ,6BAA6B;QAC7B,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,WAAW;QACX,cAAc;QACd,eAAe;QACf,UAAU;QACV,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,+BAA+B;MACjC;MACA;QACE,kBAAkB;QAClB,0BAA0B;QAC1B,uBAAuB;QACvB,8BAA8B;QAC9B,iBAAiB;QACjB,4BAA4B;QAC5B,mBAAmB;QACnB,gBAAgB;IACpB;IACA;IACA,8BAA8B;IAC9B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,YAAY;QACZ,0BAA0B;QAC1B,2BAA2B;QAC3B,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;;AAEJ;AACA;IACI;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".navigation_sub_list ul{\r\n    padding: 10px 140px 0px 140px !important;\r\n}\r\n.subMenu {\r\n    min-height: 100vh;\r\n}\r\n\r\n\r\n.nav-sub-box{\r\n    width: fit-content;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding-left:20px;\r\n    padding-right: 5px;\r\n    margin-right: 0;\r\n    position: absolute;\r\n    z-index: 999;\r\n    top: 35px;\r\n    left: 0;\r\n    border-radius: 20px;\r\n    background: rgba(0, 0, 0, 0.85);\r\n}\r\n.list-box{\r\n    padding: 20px 0 0.5rem 0;\r\n}\r\n.list-box ul{\r\n    padding-left: 0;\r\n    background: transparent;\r\n    justify-content: space-between;\r\n}\r\n.nav-sub-sub-list li{\r\n    margin-right: -5px !important;\r\n    display: none;\r\n}\r\n.list-box ul li{\r\n    text-decoration: none;\r\n    margin-bottom: 10px;\r\n    color: #fff;\r\n    height: 36px;\r\n   \r\n}\r\n.list-box ul li:hover{\r\n    text-decoration: none;\r\n}\r\n.list-box ul li a{\r\n    font-family: 'Montserrat', sans-serif;\r\n    font-size: 14px;\r\n    color: white;\r\n    font-weight: 400;\r\n    line-height: 18px;\r\n    letter-spacing: 0em;\r\n    text-align: left;\r\n    width: 102.5%;\r\n    border-bottom: 1px solid #FFF;\r\n    margin-bottom: 10px;\r\n    padding-bottom: 12px;\r\n    transition:all ease 1.2s !important;\r\n    text-decoration: none;\r\n}\r\n.list-box ul li:last-child a, .list-box ul li:last-child a:hover {\r\n    border-bottom: none;\r\n}\r\n\r\n.list-box ul li a:hover{\r\n    text-decoration: none;\r\n    background: transparent;\r\n    color: #FAEC24;\r\n    /* border-bottom: 1px solid #FAEC24; */\r\n}\r\n.list-box ul li a:focus{\r\n    background-color: transparent;\r\n    color: #FAEC24;\r\n}\r\n\r\n.nav-sub-sub-list li {\r\n    margin-bottom: 10px !important;\r\n    text-align: center !important;\r\n}\r\n.nav-sub-sub-list li a{\r\n    width: fit-content;\r\n    font-size: 12.8px !important;\r\n    color: black !important;\r\n    border-bottom: none !important;\r\n    /* background: white; */\r\n    padding: 2px 9px;\r\n    border-radius: 10px;\r\n}\r\n.dropdown-menu .clicked{\r\n    display: none;\r\n}\r\n.nav-sub-sub-list li a:hover{\r\n    color: #FFF !important;\r\n    background-color: rgba(255, 255, 255, 0.295) !important;\r\n}\r\n.nav-sub-sub-list{\r\n    display: block;\r\n}\r\n.nav-sub-sub-list .active{\r\n    display: none;\r\n}\r\n\r\n@media (max-width: 564px){\r\n    \r\n    .nav-sub-box {\r\n        width: 100%;\r\n        display: block;\r\n        margin-right: 0;\r\n        display: block;\r\n        padding: 0;\r\n        /* height: 100vh; */\r\n        background: #000;\r\n        position: static;\r\n      }\r\n      .list-box ul li a{\r\n        text-align: left;\r\n        width: 105%;\r\n        border-bottom: 1px solid #FFF;\r\n        margin-bottom: 10px;\r\n        color: #FFF;\r\n        font-family: Montserrat;\r\n        font-size: 14px;\r\n        font-style: normal;\r\n        font-weight: 380;\r\n        line-height: normal;\r\n\r\n    }\r\n    .nav-sub-sub-list li a{\r\n        width: fit-content;\r\n        font-size: 16px !important;\r\n        color: black !important;\r\n        border-bottom: none !important;\r\n        background: white;\r\n        padding: 5px 27px !important;\r\n        border-radius: 10px;\r\n        margin-top: 10px;\r\n    }\r\n    .nav-sub-sub-list li {\r\n    margin-bottom: 15px !important;    \r\n    text-align: left !important;\r\n\r\n    }\r\n    .list-box ul{\r\n        margin-top: 15px;\r\n    }\r\n    .list-box ul li{\r\n        border-bottom: none;\r\n        margin-bottom: 13px;\r\n    }\r\n    .list-box{\r\n        padding: 0px 0 1.0125rem 0;\r\n    }\r\n    .dropdown-menu .dropdown-item{\r\n        color: white;\r\n        padding-left: 20px !important;\r\n        font-size: 16px;\r\n    }\r\n    .navigation__nav .subMenu li {\r\n        padding-left: 50px;\r\n    }\r\n}\r\n@media (min-width:768px) and (max-width:992px) {\r\n    .nav-sub-box {\r\n        width: 100%;\r\n        display: block;\r\n        margin-right: 0;\r\n        padding: 0;\r\n        position: static;\r\n        /* height: 100vh; */\r\n        background: #000;\r\n        padding-bottom: 25px !important;\r\n      }\r\n      .nav-sub-sub-list li a{\r\n        width: fit-content;\r\n        font-size: 18px !important;\r\n        color: black !important;\r\n        border-bottom: none !important;\r\n        background: white;\r\n        padding: 5px 17px !important;\r\n        border-radius: 10px;\r\n        margin-top: 20px;\r\n    }\r\n    .nav-sub-sub-list li {\r\n    margin-bottom: 30px !important;    \r\n    }\r\n    .list-box ul{\r\n        margin-top: 0 !important;\r\n    }\r\n    .list-box ul li{\r\n        border-bottom: none;\r\n        margin-bottom: 20px;\r\n    }\r\n    .list-box{\r\n        padding: 0px 0 1.0125rem 0;\r\n    }\r\n    .dropdown-menu .dropdown-item{\r\n        color: white;\r\n        font-size: 17px !important;\r\n        font-weight: 380 !important;\r\n        padding: 20px;\r\n    }\r\n    .navigation__nav .subMenu li {\r\n        padding-left: 90px;\r\n    }\r\n    \r\n}\r\n@media (min-width:1400px){\r\n    .nav-sub-sub-list li{\r\n        margin-right: -13px !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
